import React, { useContext, useEffect } from "react"
import AnnouncementHeader from "@components/Header/AnnouncementHeader"
import Cart from "@components/Cart"
import MenuBar from "@components/Header/MenuBar/MenuBar"
import Footer from "@components/Footer/Footer.jsx"
import LoginModal from "@components/modal/LoginModal"
import UserContext from "@context/UserContext"
import { StoreContext } from '@context/StoreContext'
import QuickBuyContext from "@context/QuickBuyContext"
import { sendGAEvent } from "@utils/analytics"
import { updateBuyersIdentity } from "@utils";

export const Layout = ({ children, gaEvent, forceShowRegister = false, footerMargin = "mt-20", className = '' }) => {
	const { openLoginModal, setOpenLoginModal, user, token } = useContext(UserContext)
    const { checkout } = useContext(StoreContext)
	const { areHeaderMenusOpen } = useContext(QuickBuyContext)


	useEffect(() => {
		if (gaEvent) sendGAEvent(gaEvent?.eventName, gaEvent?.params)
	}, [])

    useEffect( () => {
        const checkBuysIdentity = async () => {
            if(checkout?.buyerIdentity?.email === null) {
                if(user?.email) {
                    await updateBuyersIdentity(checkout?.id, token, user?.defaultAddress?.countryCodeV2);
                }
            }
        }
        
        checkBuysIdentity();
        
    }, [user, checkout])


	return (
		<React.Fragment>
            <main className={`font-sans ${className}`}>
				<Cart />
                <header className={`${areHeaderMenusOpen ? 'fixed w-full left-0' : 'sticky'} top-0 bg-white z-[51] shadow-sm`}>
					<AnnouncementHeader />
					<MenuBar />
				</header>
				{children}
				<Footer footerMargin={footerMargin} />

				<LoginModal
					showRegisterForm={forceShowRegister}
					isOpen={openLoginModal}
					onClose={() => {
						setOpenLoginModal(false)
					}}
				/>
			</main>
		</React.Fragment>
	)
}
